<template>
  <div>
    <!--    <el-button type="primary" @click="createCarportDialog = true">创建车库</el-button>-->
    <el-row>
      <el-col
        class="groud_card"
        :span="5"
        :xs="24"
        v-for="item in carportDetailList"
        :key="item.title"
      >
        <div class="groud_card_title">
          <div class="groud_card_icon" :style="{ background: item.bgc }">
            <Icon
              class="icon_logo"
              :style="{ color: item.color }"
              :icon="item.icon"
            />
          </div>
          <div class="groud_text">{{ item.title }}</div>
        </div>
        <div class="groud_card_value">
          <!-- 收费方式 -->
          <template v-if="item.key == 'charge' && params.carportId">
            <template v-if="carportDetailObj.allowTemporaryParking === 1">
              <div class="value_share">
                临停时长：{{ carportDetailObj.temporaryParkingTime }}小时
              </div>
              <div class="value_share">
                收费金额：{{ carportDetailObj.temporaryParkingMoney }}元
              </div>
            </template>
            <template v-else>不允许临时停车</template>
          </template>
          <!-- 包月套餐 -->
          <template v-if="item.key == 'power'">
            <div
              class="value_share"
              v-for="item in carportDetailObj.agentGetCarTypeMonthlyInfoList"
              :key="item.id"
            >
              {{ item.name }}, {{ item.money }}元{{
                getChargeMonthly(item.chargeMonthlyInfoId)
              }}
            </div>
          </template>
          <!-- 分润方 -->
          <!-- <template v-if="item.key == 'share'">
            <div
              class="value_share"
              v-for="item in carportDetailObj.groupDividendConfList"
              :key="item.id"
            >
              {{ item.dividend.name }}, 分润 {{ item.dividendRatio }}%
            </div>
          </template> -->
          <!-- 具体位置 -->
          <template v-if="item.key == 'address'">
            <div class="value_share">
              {{ carportDetailObj.address }}
            </div>
          </template>
          <!-- 联系电话 -->
          <template v-if="item.key == 'mobile'">
            <div class="value_share">
              {{
                carportDetailObj.deviceGroup &&
                carportDetailObj.deviceGroup.mobile
              }}
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="5" class="m-mp-10">
      <el-form ref="params" :model="params">
        <!--              ids、车棚、状态、网络-->
        <el-col :span="4" :xs="12">
          <el-form-item prop="carportId">
            <el-select
              v-model="params.carportId"
              filterable
              ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
              placeholder="车库"
              value="groupingValue"
              @change="handleParamsQuery"
              clearable
            >
              <el-option
                v-for="item in carportList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4" :xs="24"> 
          <el-form-item prop="ids">
            <el-input
              v-model="params.ids"
              maxlength="5"
              placeholder="硬件UID"
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="3" :xs="12">
          <el-form-item prop="state">
            <el-select v-model="params.state" placeholder="状态">
              <el-option
                v-for="item in status"
                :key="item.label"
                :label="item.label"
                :value="item.value"
                @change="handleParamsQuery"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="3" :xs="12">
          <el-form-item prop="onLine">
            <el-select v-model="params.onLine" placeholder="网络">
              <el-option
                v-for="item in onLines"
                :key="item.label"
                :label="item.label"
                :value="item.value"
                @change="handleParamsQuery"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="qrCodeId">
            <el-input v-model="params.qrCodeId" placeholder="门禁二维码编号" />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="handleParamsQuery">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button plain type="success" @click="handleResetBtnClick"
            >重置</el-button
          >
        </el-col>
      </el-form>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="6" :xs="24" v-for="item in records" :key="item.id">
        <lp-list-item :item="item" :rows="dataRows">
          <template #option="scope">
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button
                type="primary"
                size="mini"
                @click="generateQrcode(scope.row)"
                >二维码</el-button
              >
            </div>
          </template>
        </lp-list-item>
      </el-col>
    </el-row>

    <!-- <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
    >
      <el-table-column
        fixed
        label="门禁二维码编号"
        prop="accessControlDeviceQrCode.id"
      /> 
      <el-table-column label="状态">
        <template #default="scope">
          <template v-if="scope.row.state === 1"> 已绑定 </template>
          <template v-else-if="scope.row.state === 0"> 未绑定 </template>
          <template v-else-if="scope.row.state === -1"> 报废 </template>
        </template>
      </el-table-column>
      <el-table-column label="网络">
        <template #default="scope">
          <template v-if="scope.row.onLine"> 在线 </template>
          <template v-else> 离线 </template>
        </template>
      </el-table-column>
      <el-table-column label="所属车库" prop="carport.name" />

      <el-table-column label="创建时间" prop="creatTime">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="generateQrcode(scope.row)"
            >二维码</el-button
          > 
        </template>
      </el-table-column>
    </el-table> -->

    <page :current="current" :size="size" :total="total" />
    <create-carport-dialog :dialog="createCarportDialog" />
    <a id="downloadLink"></a>

    <!-- 门禁二维码弹框 -->
    <el-dialog
      title="门禁二维码"
      v-if="showGenerateQrcodeDialog"
      :visible.sync="showGenerateQrcodeDialog"
      :fullscreen="dialogFullscreen"
      @close="handleQrcodeDialogClose"
    >
      <div class="qrcode_wrapper">
        <div
          ref="qrcodeRef"
          v-for="item in currGenerateQrcodeRow.version == '1.0' ? 2 : 1"
          :key="item"
          class="qrcode_box"
        >
          <div class="box_title">
            <span v-if="currGenerateQrcodeRow.version == '1.0'">{{
              item == 1 ? "进门" : "出门"
            }}</span>
            <el-button
              type="primary"
              style="margin-left: 5px"
              @click="handleQrcodeDownLoad(item - 1)"
              >下载图片</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 更换门禁弹框 -->
    <el-dialog
      title="更换门禁"
      width="25%"
      v-if="showReplaceAccessControlDialog"
      :visible.sync="showReplaceAccessControlDialog"
      :fullscreen="dialogFullscreen"
      @close="handleReplaceAccessControlDialogClose"
    >
      <div class="replace_wrapper">
        <el-input v-model="currentAccessControl.id" disabled>
          <template slot="prepend">旧门禁编号</template>
        </el-input>
        <div style="height: 20px"></div>
        <el-input placeholder="请输入新门禁编号" v-model="replaceNewQrcode">
          <template slot="prepend">新门禁编号</template>
          <template slot="append">
            <el-button plain type="success" @click="scanNewQrcode"
              >扫码获取</el-button
            >
          </template>
        </el-input>
      </div>
      <div slot="footer">
        <el-button @click="handleReplaceAccessControlDialogCancel"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="handleReplaceAccessControlDialogConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Page from "@/components/Page";
import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import CreateCarportDialog from "@/views/GarageManage/dialog/createAndEditCarportDialog";
// import createdMixin from "@/mixin/createdMixin";
import CarPort from "@/api/device/CarPort";
import agentGetAccessControlerDeviceByPage from "@/api/device/access-control-device-controler/agentGetAccessControlerDeviceByPage";
import agentReplaceAccessControlDevice from "@/api/device/access-control-device-controler/agentReplaceAccessControlDevice";
import agentUnBindAccessControlDevice from "@/api/device/access-control-device-controler/agentUnBindAccessControlDevice";
import agentGetGroupDetailById from "@/api/device/device-group-manage/agentGetGroupDetailById";
import resDispose from "@/mixin/resDisposeMixin";
import scanMixin from "@/mixin/scanMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import { Message } from "element-ui";
import QRCode from "qrcodejs2";

import LpListItem from "@/components/LpListItem.vue";

export default {
  name: "AccessControlDeviceOne",
  components: { CreateCarportDialog, Page, LpListItem },
  mixins: [
    pageMixin,
    dialogMixin,
    timeMixin,
    resDispose,
    searchMixin,
    scanMixin,
  ],
  data() {
    return {
      chargeMonthlyInfoList: [],
      showGenerateQrcodeDialog: false,
      carportDetailList: [
        {
          title: "临停收费",
          key: "charge",
          icon: "icon-shoufeiguanli",
          color: "#f83f3a",
          bgc: "rgba(248, 63, 58, 0.1)",
        },
        {
          title: "车辆类型包月套餐",
          key: "power",
          icon: "icon-yuebao",
          color: "#f1a00e",
          bgc: "rgba(244, 182, 70, 0.1)",
        },
        // {
        //   title: "分润方",
        //   key: "share",
        //   icon: "icon-zhjf",
        //   color: "#29c19b",
        //   bgc: "rgba(41, 193, 155, 0.1)",
        // },
        {
          title: "具体位置",
          key: "address",
          icon: "icon-weizhi",
          color: "#4d9aff",
          bgc: "rgba(130, 184, 255,0.1)",
        },
        {
          title: "联系电话",
          key: "mobile",
          icon: "icon-24gf-phoneLoudspeaker",
          color: "#e600ac",
          bgc: "rgba(255, 102, 204, 0.1)",
        },
      ],
      carportDetailObj: {},
      createCarportDialog: false,
      showReplaceAccessControlDialog: false,
      currentAccessControl: {},
      records: [],
      params: {
        pageNum: 1,
        size: 10,
        ids: "",
        carportName: "",
        state: "",
        onLine: "",
        sortName: "id",
        sortType: "DESC",
        carportId: undefined,
        qrCodeId: "",
      },
      carportList: [],
      status: [
        { value: "1", label: "已绑定" },
        // { value: "0", label: "未绑定" },
        { value: "-1", label: "报废" },
      ],
      onLines: [
        { value: "1", label: "在线 " },
        { value: "0", label: "离线" },
      ],
      replaceNewQrcode: "",
      currGenerateQrcodeRow: {},
      dataRows: [
        {
          label: "门禁二维码编号",
          prop: "accessControlDeviceQrCode.id",
        },
        {
          label: "网络",
          prop: "onLine",
          format: (v) => (v ? "在线" : "离线"),
        },
        { label: "所属车库", prop: "carport.name" },
        {
          label: "创建时间",
          prop: "creatTime",
          format: (v) => this.timeFormat(v),
        },
      ],
    };
  },
  created() {
    this.loadTable = false;

    CarPort.agentGetAllCarport().then((res) => {
      this.carportList = res.data;
      if (!this.params.carportId) {
        if (this.$route.query.carportId) {
          this.params.carportId = +this.$route.query.carportId;
        } else if (this.carportList.length == 1) {
          this.params.carportId = this.carportList[0].id;
        }
      }

      if (this.$route.query.status) {
        this.params.onLine = this.$route.query.status;
      }
      // if (this.params.carportId)
      this.fetchData();
    });
  },
  remove(id) {
    agentUnBindAccessControlDevice({ accessControlDeviceId: id }).then(
      (res) => {
        this.resFetch({ res });
      }
    );
  },
  watch: {
    "params.carportId": {
      handler() {
        this.getCarportDetailById(this.params.carportId);
      },
    },
  },
  methods: {
    handleQrcodeDialogClose() {},
    handleReplaceAccessControlDialogClose() {},
    generateQrcode(row) {
      this.currGenerateQrcodeRow = row;
      this.showGenerateQrcodeDialog = true;

      this.$nextTick(() => {
        // 进
        this.generatorQrcodeFn(
          `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.accessControlDeviceQrCode.id}&io=1&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
          String(row.accessControlDeviceQrCode.id).padStart(6, 0),
          this.$refs.qrcodeRef[0]
        );
        // new QRCode(this.$refs.qrcodeRef[0], {
        //   text: `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.id}&io=1&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
        //   width: 200,
        //   height: 200,
        //   colorDark: "#000",
        //   colorLight: "#fff",
        //   correctLevel: QRCode.CorrectLevel.H,
        // });

        // 版本1.0的门禁才显示两个二维码
        if (row.version == "1.0") {
          // 出
          this.generatorQrcodeFn(
            `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.accessControlDeviceQrCode.id}&io=0&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
            String(row.accessControlDeviceQrCode.id).padStart(6, 0),
            this.$refs.qrcodeRef[1]
          );
        }

        // new QRCode(this.$refs.qrcodeRef[1], {
        //   text: `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.id}&io=0&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
        //   width: 200,
        //   height: 200,
        //   colorDark: "#000",
        //   colorLight: "#fff",
        //   correctLevel: QRCode.CorrectLevel.H,
        // });
      });
    },
    generatorQrcodeFn(qrCodeUrl, qrcodeText, qrcodeDom = null) {
      let qrcodeContent = qrcodeDom || document.createElement("div");
      qrcodeContent.width = "600px";
      qrcodeContent.height = "600px";
      let qrcodeCanvas = new QRCode(qrcodeContent, {
        text: qrCodeUrl, // 需要转换为二维码的内容
        width: 600,
        height: 600,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      let resolutionMultiple = 1; // 分辨率倍数
      let borderSize = 15 * resolutionMultiple; // 边框留白
      let canvasWidth = 600 * resolutionMultiple; // 图片宽度
      // 判断 参数为空的命名情况
      let text = qrcodeText; // 底部文字
      let fontSize = 20 * resolutionMultiple; // 文字大小

      let canvasHeight = canvasWidth + fontSize + 15;
      let canvas = document.createElement("canvas");
      if (!canvas.getContext) return;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      let ctx = canvas.getContext("2d");
      ctx.fillStyle = "rgb(255,255,255)"; // 调色(纯白)
      ctx.fillRect(0, 0, canvasWidth, canvasHeight); // 绘制背景

      let qrcodeSize = canvasWidth - borderSize * 2;
      ctx.drawImage(
        qrcodeContent.querySelector("canvas"),
        borderSize,
        borderSize,
        qrcodeSize,
        qrcodeSize
      ); // 填充二维码

      ctx.fill(); // 填充背景

      ctx.fillStyle = "rgb(0,0,0)"; // 调色(纯黑)
      ctx.font = fontSize + "px Arial"; // 文本大小, 字体
      ctx.textAlign = "center";
      ctx.fillText(
        text,
        canvasWidth / 2,
        qrcodeSize + borderSize + fontSize + 15,
        qrcodeSize
      ); // 绘制文本
      // 清除原二维码
      qrcodeCanvas.clear();
      [...qrcodeContent.querySelectorAll("canvas, img")].forEach((e) =>
        e.remove()
      );
      qrcodeContent.appendChild(canvas);
      return qrcodeContent;
    },
    replaceAccessControl(row) {
      this.replaceNewQrcode = "";
      this.currentAccessControl = { ...row };
      this.showReplaceAccessControlDialog = true;
    },
    handleReplaceAccessControlDialogCancel() {
      this.showReplaceAccessControlDialog = false;
    },
    handleReplaceAccessControlDialogConfirm() {
      if (!this.replaceNewQrcode.replace(/\s/g, "")) {
        return Message({
          message: "请先输入新门禁编号!",
          type: "error",
          duration: 1500,
        });
      }
      agentReplaceAccessControlDevice(
        this.currentAccessControl.id,
        this.replaceNewQrcode
      ).then((res) => {
        this.resFetch({ res });
        if (res.code == 1) {
          this.showReplaceAccessControlDialog = false;
        }
      });
    },
    scanNewQrcode() {
      this.scan({
        callBack: (res) => {
          const isLink = res.resultStr.substring(0, 4) === "http";

          if (!isLink) {
            return this.$message.error("请扫门禁设备的二维码~");
          }
          let strList = res.resultStr.split("?");
          if (strList.length === 2) {
            let argList = strList[1].split("&");
            if (argList.length === 3) {
              if (argList[0].startsWith("accessControlDeviceId=")) {
                this.replaceNewQrcode = argList[0].split("=")[1];
              } else {
                Message.error("二维码错误");
              }
            } else {
              Message.error("二维码错误");
            }
          } else {
            Message.error("二维码错误");
          }
        },
      });
    },
    delAccessControl(row) {
      this.$confirm("确认删除该门禁?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        agentUnBindAccessControlDevice({ accessControlDeviceId: row.id }).then(
          (res) => {
            // this.resFetch({ res });
            Message({
              message: res.code === 1 ? "删除成功~" : "删除失败!",
              type: res.code === 1 ? "success" : "error",
              duration: 3 * 1000,
            });
            this.fetchData();
          }
        );
      });
    },
    handleQrcodeDownLoad(i) {
      let img = this.$refs.qrcodeRef[i].children[1];
      // 构建画布
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      // 构造url
      let url = canvas.toDataURL("image/png");
      // 构造a标签并模拟点击
      let downloadLink = document.getElementById("downloadLink");
      downloadLink.setAttribute("href", url);
      downloadLink.setAttribute("download", `${i == 0 ? "进门" : "出门"}.png`);
      downloadLink.click();
    },
    handleResetBtnClick() {
      this.reset(
        this.$route.query.carportId ? { notResetFields: ["carportId"] } : {}
      );
    },
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    getCarportDetailById(id) {
      if (!id) return (this.carportDetailObj = {});

      CarPort.agentGetCarportById({ carportId: id }).then((res) => {
        console.log(res);
        this.carportDetailObj = res.data;
        agentGetGroupDetailById({ id: res.data.groupId }).then((res) => {
          this.chargeMonthlyInfoList = res.data.monthlyInfoList || [];
        });
      });
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    handleParamsQuery() {
      this.current = 1;
      this.fetchData();
    },
    fetchData() {
      this.params.pageNum = this.current;
      this.params.size = this.size;
      agentGetAccessControlerDeviceByPage(this.params).then((res) => {
        this.records = res.data.records;
        if (this.params.ids) {
          const unique = new Set(this.records.map((r) => r.carportId));
          // 如果设备都在同一小区，则自动选中该小区，显示详细信息
          if (unique.size == 1) {
            this.$set(this.params, "carportId", this.records[0].carportId);
          }
        }

        this.total = res.data.total;
        //   console.log('===========================')
        //   console.log(res.data.records)
        // console.log('===========================')
      });
    },
    reset2() {
      this.params = {
        pageNum: 1,
        size: 10,
        ids: "",
        carportName: "",
        state: "",
        onLine: "",
        sortName: this.params.sortName,
        sortType: this.params.sortType,
        carportId: this.params.carportId,
      };
      if (this.time) {
        delete this.params.startTime;
        delete this.params.endTime;
        this.time = [];
        this.current = 1;
      }
      this.fetchData();
    },
    getChargeMonthly(chargeId) {
      const item = this.chargeMonthlyInfoList.find((c) => c.id == chargeId);
      return item
        ? ` - 最大功率${item.endPower}W,${item.money}元,${item.freeChargeNum}小时`
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .wrapper {
    .card {
      height: 80px !important;
      padding-left: 10px !important;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }
}
</style>

<style lang="scss" scoped>
@import "src/styles/my";
@include mobile {
  .card {
    height: 65px !important;
  }

  // .groud_card {
  //   .groud_card_value {
  //     height: 90px !important;
  //   }
  // }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }

  .groud_card {
    .groud_card_value {
      height: auto !important;
      max-height: 90px !important;
    }
  }

  .qrcode_wrapper {
    flex-direction: column;
    .qrcode_box {
      margin-bottom: 40px;
      margin-right: 0;
    }
  }
}

.qrcode_wrapper {
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
  .qrcode_box {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-right: 30px;
    .box_title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}

.groud_card {
  box-sizing: border-box;
  // cursor: pointer;
  border: 1px solid #f0f0f0;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 3px 5px;
  // display: flex;
  // align-items: center;
  // padding-left: 30px;
  margin-right: 16.5px;
  margin-bottom: 8px;
  border-radius: 5px;

  .groud_card_title {
    display: flex;
    align-items: center;
    // justify-content: center;
    // margin-bottom: 4px;
    font-size: 14px;
    // border-bottom: 1px solid #f4f4f4;
    padding-bottom: 5px;
    padding: 5px;
    box-shadow: 0 1px 3px #e3e3e3;

    .groud_card_icon {
      margin-right: 8px;
      // padding: 2px 3px;
      border-radius: 4px;

      .icon_logo {
        font-size: 22px;
      }
    }

    .groud_text {
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  .groud_card_value {
    padding: 4px 8px;
    height: 100px;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    font-size: 14px;

    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .value_share {
      border-bottom: 1px dashed #e4e4e4;
      margin-bottom: 3px;
      padding-bottom: 2px;
    }
  }
}
</style>
